export const GF_EXP = new Uint8Array(512);
